import { render, staticRenderFns } from "./AddBusinessName.vue?vue&type=template&id=0b5f950a&scoped=true&"
import script from "./AddBusinessName.vue?vue&type=script&lang=js&"
export * from "./AddBusinessName.vue?vue&type=script&lang=js&"
import style0 from "./AddBusinessName.vue?vue&type=style&index=0&id=0b5f950a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5f950a",
  null
  
)

export default component.exports